module.exports = __webpack_public_path__ + "static/media/wipro-logo.392378cb.jpg";